import { Card, Modal, Stack } from "@shopify/polaris";
import React, { useCallback, useEffect, useState } from "react";
import { AmazonIdeaType } from "./helper";
import styled from "styled-components";

const CUSTOMIZATION_TYPES = {
    [AmazonIdeaType.Data]:
        "Allow buyers to provide input about your product that does not affect the image priview. Ideal for custom sizing or notes",
    [AmazonIdeaType["Option Dropdown"]]:
        "Allow buyers to choose from different sets of options that you offer.",
    [AmazonIdeaType.Image]:
        "Allow buyers to personalize your product by uploading their own image.",
};

export default function AmazonIdeaAddCustomization({
    open,
    onClose,
    onChange,
}) {
    const [type, setType] = useState("");

    const handleClick = useCallback(
        (type) => () => {
            setType(type);
        },
        [],
    );

    const handleSubmit = useCallback(() => {
        onChange(type);
        onClose();
        setType("")
    }, [type]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Add Customization"
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Add Customization",
                onAction: handleSubmit,
            }}
            sectioned
        >
            <Wrapper>
                <Stack vertical>
                    {Object.entries(CUSTOMIZATION_TYPES).map(([key, value]) => (
                        <div
                            className={`${key === type ? "active" : ""}`}
                            onClick={handleClick(key)}
                            key={`custom-field-${key}`}
                        >
                            <Card title={key} sectioned>
                                <span>{value}</span>
                            </Card>
                        </div>
                    ))}
                </Stack>
            </Wrapper>
        </Modal>
    );
}

const Wrapper = styled.div`
    .Polaris-Card {
        cursor: pointer;
    }

    .Polaris-Card__Header {
        border-radius: 3px 0 0;
        padding: 1rem 2rem;
        border-bottom: var(
            --p-thin-border-subdued,
            0.1rem solid var(--p-border-subdued, #dfe3e8)
        );
    }

    .active {
        .Polaris-Card {
            outline-color: #3f4eae;
        }

        .Polaris-Card__Header {
            background: linear-gradient(to bottom, #6371c7, #5563c1);
            border: #3f4eae;

            .Polaris-Heading {
                color: white;
            }
        }
    }
`;
